
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lighting-rental",
      function () {
        return require("private-next-pages/lighting-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lighting-rental"])
      });
    }
  